import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EditButton from './EditButton';
import { sanitiseHTML, toType } from '../../../legacy/utils/helpers';
import {
    QuestionFrontendIdentifiers,
  SectionChipsColors,
  sections,
} from '../../../latest/src/containers/TherapistProfile/Tabs/sections';
import { TherapistSelections } from 'src/latest/src/containers/TherapistProfile/Tabs';
import { useIsMobile } from "src/latest/src/hooks";
import { Typography } from "src/latest/src/components";

const KeyValueContent2 = ({
  choices,
  alignVertical = false,
  secKey,
  alignHorizontal = false,
  clientAgeGroup = false,
  quesFrontendIdentifier,
  value
}) => {
  const sortedChoices = choices.sort(function(a, b) {
    return a.sequence - b.sequence;
  });
  const selectedChoices = choices.filter((c: any) => c.selected);
  const isFromMobile = useIsMobile();

  if (
    quesFrontendIdentifier === QuestionFrontendIdentifiers.paymentSection.insuranceplanTherapistQuestion ||
    quesFrontendIdentifier === QuestionFrontendIdentifiers.languagePage.languageTherapistQuestion || 
    quesFrontendIdentifier === QuestionFrontendIdentifiers.therapyLanguagePage.therapyLanguageTherapistQuestion || 
    (quesFrontendIdentifier === QuestionFrontendIdentifiers.clientAgeGroup.clientAgeTherapistQuestion && isFromMobile)
  ) {
    return (
      <TherapistSelections
        value={value}
        mergedData={selectedChoices}
        frontendIdentifier={quesFrontendIdentifier}
        showAllAtOnce={quesFrontendIdentifier === QuestionFrontendIdentifiers.paymentSection.insuranceplanTherapistQuestion}
      />
    );
  } else {
    return (
      <div
        className={`${
          alignVertical
            ? 'd-vertical-align'
            : alignHorizontal
            ? 'language-wrap'
            : clientAgeGroup
            ? 'client-age-group pb-24'
            : 'expertisewrap pb-24'
        }`}
      >
        {sortedChoices &&
          sortedChoices.map(choice => {
            if (choice.selected && clientAgeGroup === false) {
              return (
                <React.Fragment>
                  <div
                    key={choice?.unique_key}
                    className={
                      SectionChipsColors[quesFrontendIdentifier]
                        ? 'wrapper-class'
                        : 'mb-3'
                    }
                    style={{
                      backgroundColor:
                        SectionChipsColors[quesFrontendIdentifier],
                    }}
                  >
                    <Typography
                      variant={`size-16`}
                      weight={`regular`}
                      color="color-2"
                      className={`user-profile-content-prim ${
                        alignHorizontal && 'language-data'
                      } ${
                        secKey?.toLowerCase().includes('paymentsection') &&
                        choice?.unique_key
                          ?.toLowerCase()
                          .includes('feetherapistchoicev1') &&
                        'ellipsis-session-fee'
                      }`}
                    >
                      {secKey?.toLowerCase().includes('paymentsection') &&
                        choice?.unique_key
                          ?.toLowerCase()
                          .includes('feetherapistchoicev1') &&
                        '$'}
                      {sanitiseHTML(
                        choice.display_title || choice.value || choice.title,
                      )}
                    </Typography>
                  </div>
                </React.Fragment>
              );
            } else if (clientAgeGroup === true) {
              return (
                <div className="block" key={choice?.unique_key}>
                  <Typography
                    variant={`size-16`}
                    weight={`regular`}
                    color="color-2"
                    className={`user-profile-content-prim ${
                      choice.selected
                        ? 'selected-pill-text'
                        : 'not-selected-pill-text'
                    }`}
                  >
                    {choice.display_title}
                  </Typography>
                  <div
                    className={
                      choice.selected
                        ? 'pill selected-pill'
                        : 'pill not-selected-pill'
                    }
                  />
                </div>
              );
            } else {
              return <></>;
            }
          })}
      </div>
    );
  }
};

// This Function is used to hide sub section like insurance and year of graduation
const isSubSectionHasData = question => {
  let showSection = true;

  if (question?.choices.length <= 0) {
    showSection = false;

    return showSection;
  }

  if (question) {
    if (question?.choices.filter(choice => choice.selected).length <= 0) {
      showSection = false;
    }
  }

  return showSection;
};

const Content2 = ({
  title,
  value,
  isRemoveTitle,
  icon,
  bgColor,
  color,
  secKey,
  alignVertical = false,
  alignHorizontal = false,
  clientAgeGroup,
  showPage,
}) => {
  if (value && value?.questions) {
    value.questions = value?.questions.filter(question =>
      sections[secKey].questionIdentifier.includes(
        question.frontend_identifier,
      ),
    );

    return (
      <>
        {value &&
          value?.questions?.map((question, index) => {
            let typographyClassName = 'user-profile-content-prim';

            if (isRemoveTitle) {
              typographyClassName += 'mt-0';
            }

            return (
              isSubSectionHasData(question) ? (
                <div key={question.display_title + index}>
                    <EditButton section={value} showPage={showPage} />
                  {!isRemoveTitle && (
                    <Typography
                      variant="size-14"
                      weight="bold"
                      color="color-28"
                      className="new-therapist-profile__title mb-3"
                    >
                      {question.display_title || title}
                    </Typography>
                  )}
                  {toType(question.choices) === 'array' &&
                  toType(question.choices[0]) === 'object' ? (
                    <KeyValueContent2
                      choices={question.choices}
                      alignVertical={alignVertical}
                      secKey={secKey}
                      alignHorizontal={alignHorizontal}
                      clientAgeGroup={clientAgeGroup}
                      quesFrontendIdentifier={question?.frontend_identifier}
                      value={value}
                    />
                  ) : (
                    <div
                      className={
                        icon ? 'therapist-profile__icon-container' : ''
                      }
                    >
                      {icon && (
                        <span
                          className="therapist-profile__icon"
                          style={{ background: bgColor }}
                        >
                          <FontAwesomeIcon icon={icon} color="#fff" />
                        </span>
                      )}
                      <Typography
                        variant="size-16"
                        weight="regular"
                        color={color !== undefined ? color : 'color-2'}
                        className={typographyClassName}
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: question.value }}
                        />
                      </Typography>
                    </div>
                  )}
                </div>
              ) : (
                <div key={question.display_title + index}>
                  <EditButton section={value} showPage={showPage} />
                  {!isRemoveTitle && (
                    <Typography
                      variant="size-14"
                      weight="bold"
                      color="color-28"
                      className="new-therapist-profile__title mb-3"
                    >
                      {question.display_title || title}
                    </Typography>
                  )}
                  <Typography
                    className="pb-24"
                    variant="size-16"
                    weight="regular"
                    color="color-2"
                  >
                    N/A
                  </Typography>
                </div>
              )
            );
          })}
      </>
    );
  } else {
    return <></>;
  }
};

export default Content2;
